import { questionReportingByQuestionStore } from '../../../reducers/Question/QuestionReporting/questionReporting.reducer';
import { questionsReportingStore } from '../../../rootReducer';

export function selectAllReportByQuestion(state) {
    return state[questionsReportingStore][questionReportingByQuestionStore];
}
